export const limitDealerListPerPage = 5;

export const lineLink = "https://line.me/R/ti/p/~";
